// 如果url有token 跳转到login
var token = new URLSearchParams(window.location.search).get('token')
var href = window.location.href

if (token && href && href.indexOf('account/login') === -1) {
  // 获取token
  location.href = `/account/login?return_url=${window.location.href}&token=${token}`
}